import { createContext } from 'react';

const GlobalConfig = createContext();

export default GlobalConfig;
